import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const CTA = () => {
  const navigate = useNavigate();

  const handleStartCampaign = async () => {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (session) {
      navigate('/create-fundraiser');
    } else {
      navigate('/auth', { state: { defaultTab: 'signup', defaultUserType: 'fundraiser' } });
    }
  };

  return (
    <section className="relative py-16 sm:py-20 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-background to-emerald-500/10 -z-10" />
      <div className="pointer-events-none absolute -top-24 -right-24 w-96 h-96 rounded-full bg-primary/20 blur-3xl -z-10" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-emerald-400/20 blur-3xl -z-10" />
      <div className="container mx-auto px-4 sm:px-6 lg:px-12 max-w-7xl relative z-10">
        <div className="max-w-3xl mx-auto text-center animate-scale-in space-y-6">
          <div className="inline-flex items-center gap-3 mx-auto">
            <span className="h-px w-8 bg-primary/60" />
            <span className="text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase text-primary">
              Your move
            </span>
            <span className="h-px w-8 bg-primary/60" />
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.05] text-foreground">
            Start the fundraiser{" "}
            <span className="font-serif italic font-medium text-primary">you've been</span>{" "}
            putting off.
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground px-4">
            Set it up in minutes. Share it in seconds. Keep every pound your supporters give.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
            <Button 
              variant="default" 
              size="lg" 
              className="rounded-full px-6 sm:px-8 w-full sm:w-auto"
              onClick={handleStartCampaign}
            >
              Start Your Campaign
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="rounded-full px-6 sm:px-8 w-full sm:w-auto"
              onClick={() => navigate('/page/contact-support')}
            >
              Contact Support
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
